module.exports = __webpack_public_path__ + "static/youtube-5ed151fbc96a63a6817b30ccb11eb4ab.png";